import { Zap, Clock } from 'lucide-react';
import type { TriggerSuggestion } from '@ah/people/shared';

export function TriggerCard({ trigger }: { trigger: TriggerSuggestion }) {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Zap size={16} className="text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-[17px] leading-snug text-foreground">{trigger.label}</p>
            <p className="flex items-center gap-1 text-[12px] text-muted-foreground mt-1">
              <Clock size={11} />
              {trigger.cadence}
            </p>
          </div>
        </div>

        <div className="border-l-2 border-primary/40 pl-4 py-1">
          <p className="text-[10px] uppercase tracking-wider text-primary/80 font-semibold mb-1.5">
            On your behalf
          </p>
          <p className="text-[15px] text-foreground/90 leading-relaxed">
            {trigger.prompt}
          </p>
        </div>

        <p className="text-[13px] text-muted-foreground leading-relaxed">
          Activate to let your Underling run this automatically. You can
          pause or tweak it any time.
        </p>
      </div>
    </div>
  );
}
